<template>
	<div class="integral pad">
		<p class="explain">我的积分</p>
		<div class="explain_num">{{user.jf}}</div>
		<p class="explain_record">
			<img src="/static/line.png" alt="">
			<span>积分说明</span>
		</p>
	</div>
</template>

<script>
import {
  Current,
  Auth_Logout
} from "@/api/api.js"

export default {
  data () {
    return {
		user:{
			jf:0.00
		}
    }
  },
  methods:{
	  login:function(){
		  let that = this;
		  that.$router.push('/wechat/home');
	  }
  },
  created:function(){
	  let that = this;
	  Current({},function(res){
		that.user = res.model;
	  })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/wechat/point.vue